import React from 'react';
import styles from '../../static/css/pages.module.css';
import Title from "../../components/title/title";
import Icon from "../../components/icons/icons";
import ieSvg from "../../components/icons/ieSvg";

class ServerTimeout extends React.Component {

  componentDidMount() {
    ieSvg();
  }

  render() {
    return (
      <div className={styles.content}>
        <div>
          <div className="l-grid_pt-8 mobile_l-grid">
            <div className="l-grid__item_1"></div>
            <div className="l-grid__item_6 mobile_l-grid__item_10">
              <Title icon={this.props.pageIcon} title={this.props.pageTitle}/>
              <div className="l-align_center">
                <div className={styles.serviceIcon}>
                  <Icon name="icon_error-data" viewbox="0 0 227 120" />
                </div>
                Данные не получены.<br />
                Повторите операцию позже.
                <div className={styles.article}>&nbsp;</div>
                <div className={styles.article}>&nbsp;</div>
                <div className={styles.article}>&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ServerTimeout;
